import { Col, Row } from "react-bootstrap";

export default function LogoMascot() {
  return (
    <div
      style={{
        lineHeight: "2",
        padding: "20px",
        border: "1px solid #ddd",
        borderRadius: "8px",
      }}
    >
      {/* Tournament Logo Section */}

      {/* <div style={{ lineHeight: "2", marginTop: "50px" }}>
        <h3>आधिकारिक लोगो</h3>
        <br />
        <Row>
          <Col md={8}>
            <p style={{ textAlign: "justify", marginBottom: "15px" }}>
              राजगीर (बिहार) में आयोजित एशिया रग्बी अंडर-20 सेवेंस चैंपियनशिप का
              यह लोगो राज्य की ऐतिहासिक विरासत, सांस्कृतिक विविधता और खेल
              संस्कृति का जीवंत प्रतीक है।
            </p>
            <p style={{ textAlign: "justify", marginBottom: "15px" }}>
              BIHAR — यह शब्द केवल पाँच अक्षरों का संयोजन नहीं, बल्कि बिहार की
              आत्मा का चित्रात्मक परिचय है। हर अक्षर एक प्रतीक है, जो राज्य की
              सांस्कृतिक, ऐतिहासिक और प्राकृतिक विरासत की कहानी कहता है।
            </p>
          </Col>
          <Col md={4}>
            <img
              src="./img/AsiaRugbyU207s/logo.png"
              alt="Description"
              style={{ width: "100%", height: "auto", objectFit: "cover" }}
            />
          </Col>
        </Row>
        <br />
        <h4 style={{ textAlign: "justify" }}>अक्षरों का प्रतीकात्मक अर्थ:</h4>
        <br />
        <ul style={{ textAlign: "justify", paddingLeft: "20px" }}>
          <li style={{ listStyleType: "disc" }}>
            <b>B – बुद्ध और बोधि वृक्ष:</b>
            <p>
              यह अक्षर बोधगया और भगवान बुद्ध को दर्शाता है, जहाँ उन्हें ज्ञान की
              प्राप्ति हुई थी। यह बिहार की आध्यात्मिक विरासत और शांति के वैश्विक
              संदेश का प्रतीक है।
            </p>
          </li>
          <li style={{ listStyleType: "disc" }}>
            <b>I – नदी और छठ पूजा:</b>
            <p>
              यह अक्षर बिहार की जीवन रेखा गंगा नदी और छठ पूजा की भावनात्मक छवि
              प्रस्तुत करता है। यह श्रद्धा, प्रकृति से जुड़ाव और सांस्कृतिक गौरव
              का प्रतीक है।
            </p>
          </li>
          <li style={{ listStyleType: "disc" }}>
            <b>H – फसल कटाई:</b>
            <p>
              इसमें एक किसान को फसल काटते हुए दर्शाया गया है — यह बिहार की कृषि
              परंपरा, मेहनती ग्रामीण जीवन और राज्य की बागवानी उत्पादन में अग्रणी
              भूमिका को सम्मान देता है।
            </p>
          </li>
          <li style={{ listStyleType: "disc" }}>
            <b>A – गौर और गौरैया:</b>
            <p>
              भारतीय गौर (राज्य पशु) और गौरैया (राज्य पक्षी) इस अक्षर में दर्शाए
              गए हैं। यह बिहार की जैव विविधता, पर्यावरणीय संतुलन और प्राकृतिक
              समृद्धि का प्रतीक है।
            </p>
          </li>
          <li style={{ listStyleType: "disc" }}>
            <b>R – प्राचीन विश्वविद्यालयों के अवशेष:</b>
            <p>
              यह अक्षर नालंदा और विक्रमशिला विश्वविद्यालयों की ऐतिहासिक
              वास्तुकला से प्रेरित है — यह बिहार की प्राचीन शिक्षा प्रणाली,
              बौद्धिक विरासत और वैश्विक ज्ञान-परंपरा को दर्शाता है।
            </p>
          </li>
        </ul>
        <br />
        <h5 style={{ textAlign: "justify" }}>रंग योजना और भाव</h5>
        <br />
        <p style={{ textAlign: "justify" }}>
          इस लोगो में प्रयुक्त रंग — नीला, हरा और मिट्टी के रंग — बिहार की
          प्रकृति, संस्कृति और जीवन ऊर्जा को व्यक्त करते हैं। आधुनिक रेखांकन
          शैली इसे समकालीन बनाते हैं, जबकि प्रतीकात्मकता इसे गहराई देती है।
        </p>
        <p style={{ textAlign: "justify" }}>
          यह डिज़ाइन सिर्फ एक पहचान नहीं, बल्कि बिहार की आत्मा का रचनात्मक
          चित्रण है — परंपरा और आधुनिकता का सुंदर संगम।
        </p>
        <br />
      </div> */}

      {/* Mascot Section */}

      <div style={{ marginBottom: "30px" }}>
        <h2 style={{ fontSize: "22px", marginBottom: "15px" }}>
          Mascot of Men’s Asia Hockey Cup 2025 'Chaand'
        </h2>
        <p style={{ textAlign: "justify", marginBottom: "15px" }}>
          The mascot for the Men’s Asia Hockey Cup 2025 is Chaand- a fierce
          tiger draped in a red cape of courage and crowned with a magician’s
          hat, symbolising skill, spirit, and showmanship.
        </p>
        <Row style={{ marginBottom: "0px" }}>
          <Col md={8}>
            <ul style={{ paddingLeft: "20px", textAlign: "justify" }}>
              <li style={{ listStyleType: "disc" }}>
                Inspired by our national animal and the majestic tigers of
                Bihar’s Valmiki Tiger Reserve, Chaand embodies strength,
                agility, and pride. His name pays homage to the legendary Major
                Dhyanchand, the “Wizard of Hockey-Hockey ka Jadugar,” whose
                dedication to the game saw him practice under moonlight after
                army duty (‘Chand’ meaning moon in Hindi).
              </li>
              <li style={{ listStyleType: "disc" }}>
                In his action-ready stance, hockey stick gripped firm, eyes
                locked on the goal, Chaand channels the focus and control that
                made Dhyanchand a legend. The magician’s hat honours the hockey
                wizard’s unmatched skill, while the tiger form represents raw
                power and fearless spirit.
              </li>
              <li style={{ listStyleType: "disc" }}>
                The Padma Bhushan, India’s third-highest civilian award, rests
                proudly on his chest, marking the nation’s deep respect for the
                man who inspired him. Every detail-from the muscular build to
                the forward lean-reflects discipline, drive, and an unshakable
                will to win.
              </li>
              <li style={{ listStyleType: "disc" }}>
                Chaand is not just a mascot. He is the roar of determination,
                the magic of hockey, and the beating heart of Bihar’s sporting
                future. His story fuses tradition, excellence, and playfulness,
                turning the Men’s Asia Hockey Cup 2025 into more than a
                tournament-into a movement.
              </li>
              <li style={{ listStyleType: "disc" }}>
                The Cup’s inaugural day, 29th August, aligns with Major
                Dhyanchand’s birthday, celebrated nationwide as National Sports
                Day-a fitting tribute to the Wizard of Hockey. With Chaand
                leading the way, Bihar proudly roars its commitment to bringing
                hockey to the forefront.
              </li>
            </ul>
          </Col>
          <Col md={4}>
            <img
              src="/img/HeroMensHockeyAsiaCup2025Rajgir/mascot.jpg"
              alt="Description"
              style={{ width: "100%", height: "auto", objectFit: "cover" }}
            />
          </Col>
        </Row>
      </div>
    </div>
  );
}
